import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getUserExistingPermissions = (id:string) => {
  return axiosPrivate.get(`/dashboard/v1/staff_management/${id}/existing_permissions`);
};